import { Grid, Typography } from "@material-ui/core"
import { useStyles } from "./card-historico-atualizacoes-styles"
import { useCallback } from "react"
import { useThemeQueries } from "views/theme"
import { DefaultCard } from "../components"
import { AvancarIcon } from "views/components/icons"

export interface CardHistoricoAtualizacoesProps {
    titulo: string
    tipo_log: number
    descricao: string
    link_clickup: string
}

export const CardHistoricoAtualizacoes = ({ descricao, link_clickup, tipo_log, titulo }: CardHistoricoAtualizacoesProps) => {

    const classes = useStyles()
    const { theme: { palette } } = useThemeQueries()

    const tipoTarefa = useCallback((tipo: number) => {
        const tipos: Record<number, { titulo: string, cor: string }> = {
            1: {
                titulo: 'Melhoria',
                cor: palette.success.main
            },
            2: {
                titulo: 'Bug',
                cor: palette.warning.main
            },
            5: {
                titulo: 'Sustentação',
                cor: palette.error.main
            },
            3: {
                titulo: 'Nova versão',
                cor: palette.success.main
            },
            6: {
                titulo: 'Nova Funcionalidade',
                cor: palette.success.main
            },
            4: {
                titulo: 'Homologação de Funcionalidade',
                cor: palette.success.main
            }
        }
        return tipos[tipo] || { titulo: 'Outros', cor: '' };
    }, [palette.error.main, palette.success.main, palette.warning.main])

    return (
        <DefaultCard
            className={classes.card}
            onClick={() => {
                if (link_clickup) {
                    window.open(link_clickup, '_blank')
                }
            }}
        >
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant='body2' className={classes.tituloTarefa}>
                        {titulo}
                    </Typography>
                </Grid>
                <Grid item xs className={classes.infoTarefa}>
                    <Grid style={{ backgroundColor: tipoTarefa(tipo_log).cor }} className={classes.tpLog}>
                        <Typography variant='caption' className={classes.tpLogTitulo}>
                            {tipo_log && tipoTarefa(tipo_log).titulo}
                        </Typography>
                    </Grid>
                    <Typography variant='caption'>
                        {(descricao ?? '').trim()}
                    </Typography>
                </Grid>
            </Grid>
            {link_clickup && (
                <div className={classes.editIcon}>
                    <AvancarIcon tipo="BUTTON" />
                </div>
            )}
        </DefaultCard>
    )
}